import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./page.css";
import Baseurl from "../BaseURL/Baseurl";

const DriverTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterData, setFilterData] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${Baseurl.baseurl}get-drivers-data-all`);
        setData(response?.data?.records);
        setLoading(false); // Stop loader once data is fetched
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const driverFilter = (e) => {
    setFilterData(e.target.value);
  };

  const filteredResults = data?.filter((item) => {
    return (
      item.Driver.toLowerCase().includes(filterData.toLowerCase()) ||
      item.Born.toLowerCase().includes(filterData.toLowerCase()) ||
      item.Died.toLowerCase().includes(filterData.toLowerCase()) ||
      item.Home.toLowerCase().includes(filterData.toLowerCase())
    );
  });

  const Loader = () => {
    return (
      <div className="loader-wrapper">
        <div className="loader">
          <img
            className="loaderimg"
            src="/assets/images/loader.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  };
  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="container">
        <section className="about-area pb-60">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div
                  className="banner-filter-form mt-40"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <p className="text font-lg text-black font-bold">
                    I’m Looking for
                  </p>

                  <div
                    className="card p-30 shadow-lg bg-dark"
                    style={{ marginLeft: "-13px" }}
                  >
                    <form action="#">
                      <div className="row align-items-center justify-content-center">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-md-3 col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="location"
                                  className="font-sm text-light"
                                >
                                  Driver
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Driver"
                                  onChange={driverFilter}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="location"
                                  className="font-sm text-light"
                                >
                                  Born
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Born"
                                  onChange={driverFilter}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="model"
                                  className="font-sm text-light"
                                >
                                  Died
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Died"
                                  onChange={driverFilter}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="location"
                                  className="font-sm text-light"
                                >
                                  Home
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Home"
                                  onChange={driverFilter}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tablees-container">
          {loading ? (
        <Loader />
      ) : (
              <table className="table  table-dark table-striped table-bordered border-light">
                <thead>
                  <tr style={{ width: "100%", textAlign: "center" }}>
                    <th scope="col" style={{ width: "25%", color: "#EE1242" }}>
                      Driver
                    </th>
                    <th scope="col" style={{ width: "25%", color: "#EE1242" }}>
                      Born
                    </th>
                    <th scope="col" style={{ width: "25%", color: "#EE1242" }}>
                      Died
                    </th>
                    <th scope="col" style={{ width: "25%", color: "#EE1242" }}>
                      Home
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredResults?.map((item) => (
                    <tr key={item.id} style={{ width: "100%" }}>
                      <th
                        onClick={() =>
                          navigate(`/driver/${item.UUID}`, { state: { item } })
                        }
                      >
                        &nbsp; &nbsp;
                        {console.log(item.Driver, "usamaitm")}
                        <img
                          src={`https://${item.Rider_Country_Img}`} // Updated line
                          alt="Country"
                          onLoad={() =>
                            console.log(
                              `Image loaded: ${item.Rider_Country_Img}`
                            )
                          }
                          onError={() =>
                            console.error(
                              `Error loading image: ${item.Rider_Country_Img}`
                            )
                          }
                        />
                        &nbsp; &nbsp;
                        <Link className="namtext">{item.Driver}</Link>
                      </th>
                      <th style={{ textAlign: "center" }}>{item.Born}</th>
                      <th style={{ textAlign: "center" }}>{item.Died}</th>
                      <th style={{ textAlign: "center" }}>{item.Home}</th>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default DriverTable;
